/* Other imports. */
import { multimediaFormats } from "@src/constants";

/**
 * Returns the friendly name from a format code.
 *
 * @param formatCode The edition format code.
 * @returns Friendly format name
 */
// eslint-disable-next-line import/prefer-default-export
export function getFormat(formatCode: string) {
  const format = Object.values<any>(multimediaFormats).find(
    (object) => object.code === formatCode,
  );

  return format ? format.name : "Unknown";
}

export function getAgeRange(age) {
  const ageInt = parseInt(age)
  const siteCodename = process.env.GATSBY_SITE_CODENAME

  if(siteCodename === "ZA" ) {
    if(ageInt < 5) {
      return "0-5 years";
    } else if (ageInt >= 6 && ageInt < 10) {
      return "6-9 years";
    } else if (ageInt >= 10 && ageInt < 13) {
      return "10-12 years";
    } else if (ageInt >= 13 && ageInt < 15) {
      return "13-15 years";
    } else if (ageInt >= 15 && ageInt < 17) {
      return "15+ years";
    }
  } else {
    if(ageInt <= 3) {
      return "Baby and toddler";
    } else if (ageInt > 3 && ageInt <= 6) {
      return "Ages 3-5";
    } else if (ageInt > 6 && ageInt <= 9) {
      return "Ages 6-8";
    } else if (ageInt > 9 && ageInt <= 12) {
      return "Ages 9-12";
    } else if (ageInt > 12 && ageInt <= 17) {
      return "Young Adult";
    }
  }
}
